import { render, staticRenderFns } from "./investorEvaluation.vue?vue&type=template&id=3859fee0&scoped=true"
import script from "./investorEvaluation.vue?vue&type=script&lang=js"
export * from "./investorEvaluation.vue?vue&type=script&lang=js"
import style0 from "./investorEvaluation.vue?vue&type=style&index=0&id=3859fee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3859fee0",
  null
  
)

export default component.exports